
import React from 'react';

import { Tab } from "semantic-ui-react";

import InputPane from './panes/input';
import LearnMore from './panes/learnMore';

const panes = [
  { menuItem: 'User Input', render: () => <InputPane /> },
  { menuItem: 'Learn More', render: () => <LearnMore /> },
]
const LeverPane = () => {
  return <Tab menu={{ secondary: true, pointing: true }} panes={panes} />;
}

export default LeverPane;



// WEBPACK FOOTER //
// ./src/pages/modelCity/cityPane.js